export default __webpack_public_path__ + "stuffedCrustCheese.7867a7dd.png";